import { AssignmentPricing } from "./assignment-pricing";
import { AssignmentSalary } from "./assignment-salary";
import { Employee } from "./employee";
import { Organization } from "./organization";
import { SalaryRule } from "./salary-rule";
import { User } from "./user";
import { AssignmentProductMapping } from "./assignment-product-mapping";

export class Assignment {
    id!: number;
    created_at!: Date;
    updated_at!: Date;
    created_by_id!: number;
    created_by: User = new User();
    updated_by_id!: number;
    updated_by: User = new User();
    name!: string;
    name_en!: string;
    name_ka!: string;
    name_ru!: string;
    uuid!: string;
    salary_rules_id!: number;
    salary_rules!: SalaryRule;
    pricings!: AssignmentPricing[];
    salaries!: AssignmentSalary[];
    show_customers!: boolean;
    notes!: string;
    notes_local!: string;
    notes_en!: string;
    notes_ka!: string;
    notes_ru!: string;
    minimum_order!: number;
    employees: Employee[] = []
    products: AssignmentProductMapping[] = []
    notes_short!: string
    instructions!: string
    picture!:string
    interview_prompt!: string
    description_local!: string;
    remote_work!: boolean;
    slug!: string
    max_hours_per_day!: number;
    description!: string;
    organizations: Organization[] = []
    updating!: boolean
}
